import { render, staticRenderFns } from "./CategoryListUnderEvent.vue?vue&type=template&id=dd3394d8&"
import script from "./CategoryListUnderEvent.vue?vue&type=script&lang=js&"
export * from "./CategoryListUnderEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports